//export const http = "http://localhost:8080";
export const http = "http://139.59.162.67";

//export const front = "http://localhost:3001";
//export const front = "139.59.162.67;
